/**
 * Enum of endpoint suffixes available from the server.
 */
export enum FitTestAlgorithm {
  QNFT = 0,
  FastFit = 1,
  QLFT = 2
}
